// NOTE: Several functions not being used from this file. Cleanup required to eliminate the unrequired methods.
// Some of the methods seem good contenders for a common logic across MFE's

import { filter, isArray } from 'lodash'

export const filterWithMultipleMatches = (collections, filterObj) => {
  if (isArray(collections)) {
    return filter(collections, filterObj)
  }
}

/**
 * to convert an array of objects
 * @param {Array} array
 * @param {string} key
 * @returns {Object}
 */

export const arrayToObject = (array, key) =>
  array.reduce((acc, curr) => {
    acc[curr[key]] = curr
    return acc
  }, {})

/**
 * to convert our exisiting AttributeSchemaValue to canvas option format
 * @param {options} array // Options array with object of type AttributeSchemaValue
 */

export const formatOptions = (options) => {
  return options.map((option) => ({
    value: option.value,
    id: JSON.stringify(option.value),
    label: option.displayValue,
  }))
}

/**
 * to convert object to array
 * @param {Object} filterObject
 * @returns {Object}
 */

export const convertFiltersToArray = (filterObject) => {
  if (!filterObject || typeof filterObject !== 'object') {
    return []
  }

  return Object.keys(filterObject).map((key) => filterObject[key])
}

// Detect the Partneronline | External or Internal users
export const isPartnerOnline = () => {
  const url = window.location.href
  return /(^([^/]+:)?\/{2,3}[^/]+?(\.partnersonline\.com)(:|\/|$))/i.test(url)
}
const isItemHubDomainExternal = () => {
  const regex =
    /^https:\/\/itemhub\.(?:[a-zA-Z]+\.)?partnersonline\.com(?:\/.*)?$/i // Itemhub External environment - Partners online
  return regex.test(window.location.href)
}
const isItemhubDomainInInternal = () => {
  // const regex = /^https:\/\/itemhub\.(\w+)\.target\.com\/(\w+)\/.*$/i // Itemhub Internal environment - dev|prod.target.com
  const regex = /^https:\/\/itemhub\.(?:[a-zA-Z]+\.)?target\.com(?:\/.*)?$/i
  // const regex = /^https:\/\/itemhub\.(\w+)\.target\.com\/(\w+)\/?$/i
  return regex.test(window.location.href)
}
export const LoginRedirectPath = () => {
  let url = `${window.location.origin}/auth/login`
  if (isItemHubDomainExternal() || isItemhubDomainInInternal()) {
    url = `${window.location.origin}/${window.location.pathname.split('/')[1]}`
  }
  return url
}

export const findAppPath = () => {
  const localhostLists = ['localhost', 'localhost.target.com']
  const hostname = window.location.hostname
  const isLocal = localhostLists.includes(hostname)

  if (isLocal) {
    return ''
  }

  const pathSegments = window.location.pathname.split('/')
  const dynamicPath = pathSegments[1] ? `/${pathSegments[1]}` : ''

  if (isItemhubDomainInInternal() || isItemHubDomainExternal()) {
    return dynamicPath
  }

  return ''
}

export const isItemHub =
  isItemhubDomainInInternal() || isItemHubDomainExternal()

export const typeMapper = {
  vendor: 'string',
  productBrand: 'number',
}
export const mapValueTypeWithId = (id, value) => {
  const type = typeMapper[id]

  switch (type) {
    case 'string':
      return String(value)
    case 'number':
      return Number(value)
    default:
      return value
  }
}

export function writeFiltersToLocalStorage(key, obj) {
  const value = readJsonFromLocalStorage(key)
  if (value?.uId !== btoa(obj?.uId)) {
    localStorage.removeItem(key)
  }
  const data = {
    filters: {
      ...obj?.filters,
      searchText: obj?.searchText,
    },
    savedSearch: {
      activeSavedSearchId: obj?.savedSearch?.activeSavedSearchId,
    },
    uId: btoa(obj?.uId),
  }
  localStorage.setItem(key, JSON.stringify(data))
}
export function readJsonFromLocalStorage(key) {
  const localValue = localStorage.getItem(key)
  return localValue ? JSON.parse(localValue) : ''
}

export const isItemhubDomain = window.location.host.includes('itemhub')
